const sharedObservers = {
	_intersectionObserver: null,
	_resizeObserver: null,
	_intersectionCallbacks: new Map(),
	_resizeCallbacks: new Map(),

	getIntersectionObserver() {
		if (!this._intersectionObserver || "IntersectionObserver" in window) {
			this._intersectionObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						const callback = this._intersectionCallbacks.get(
							entry.target,
						);
						if (callback) {
							callback(entry.isIntersecting);
						}
					});
				},
				{
					threshold: 0.1,
					rootMargin: "100px 0px 100px 0px",
				},
			);
		}
		return this._intersectionObserver;
	},

	getResizeObserver() {
		if (!this._resizeObserver) {
			this._resizeObserver = new ResizeObserver((entries) => {
				entries.forEach((entry) => {
					const callback = this._resizeCallbacks.get(entry.target);
					if (callback) {
						callback(entry.contentRect.height);
					}
				});
			});
		}
		return this._resizeObserver;
	},

	observeIntersection(element, callback) {
		if (!element || !("IntersectionObserver" in window)) return () => {};

		this._intersectionCallbacks.set(element, callback);
		this.getIntersectionObserver().observe(element);

		return () => {
			this._intersectionCallbacks.delete(element);
			this.getIntersectionObserver().unobserve(element);
		};
	},

	observeResize(element, callback) {
		if (!element) return () => {};

		this._resizeCallbacks.set(element, callback);
		this.getResizeObserver().observe(element);

		return () => {
			this._resizeCallbacks.delete(element);
			this.getResizeObserver().unobserve(element);
		};
	},
};

export default sharedObservers;
